import { render, staticRenderFns } from "./TitleForResultList.vue?vue&type=template&id=aef42bfe&scoped=true&"
import script from "./TitleForResultList.vue?vue&type=script&lang=js&"
export * from "./TitleForResultList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef42bfe",
  null
  
)

export default component.exports